//引入element-ui框架语言配置
import locale from "element-ui/lib/locale";
import elementEnLocale from "element-ui/lib/locale/lang/en";
import elementEsLocale from "element-ui/lib/locale/lang/es";
import elementPtLocale from "element-ui/lib/locale/lang/pt-br";
import elementTrLocale from "element-ui/lib/locale/lang/tr-TR";
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN";
import Vue from "vue";
import VueI18n from "vue-i18n";
import zhLocale from "./locale/zh.json";
import { getLangVersion, getLangJson } from "@/api/i18n";
import store from "@/store";

// 默认语言列表
const defaultLangList = ["zh", "en", "tr", "pt", "es"];

// element-ui语言包
const elementLang = {
	en: elementEnLocale,
	zh: elementZhLocale,
	tr: elementTrLocale,
	pt: elementPtLocale,
	es: elementEsLocale
};

const langJson = JSON.parse(localStorage.getItem("langJson") || "{}");

// 全局注册国际化包
Vue.use(VueI18n);

const messages = defaultLangList.reduce((prev, cur) => {
	if (!prev[cur]) {
		prev[cur] = {
			...elementLang[cur],
			...zhLocale,
			...langJson
		};
	}

	return prev;
}, {});

// 获取当前语言类型
const currentLang = localStorage.getItem("lang") || "zh";

// 准备翻译的语言环境信息
const i18n = new VueI18n({
	locale: currentLang || "zh", //将语言标识存入localStorage或sessionStorage中，页面刷新不会默认中文显示
	messages,
	silentTranslationWarn: true, //解决vue-i18n黄色警告"value of key 'xxx' is not a string"和"cannot translate the value of keypath 'xxx'.use the value of keypath as default",可忽略
	globalInjection: true, // 全局注入
	fallbackLocale: currentLang || "zh" // 指定的locale没有找到对应的资源或当前语种不存在时，默认设置当前语种为中文
});

// 为了实现element插件的多语言切换
locale.i18n((key, value) => i18n.t(key, value));

export const initI18n = async (lang) => {
	// 获取当前语言版本号
	const version = localStorage.getItem("langVersion");
	// 获取当前语言
	const currentLang = localStorage.getItem("lang") || "zh";
	// 当前用户设置的语言
	const userLang = lang || store.getters.userInfo.language_current || "zh";
	// 语言包JSON
	const langJsonStr = localStorage.getItem("langJson");

	// eslint-disable-next-line no-console
	console.debug(`[i18n] 当前系统语言为: ${currentLang}, 当前用户语言为: ${userLang}`);

	try {
		// 获取语言包版本号
		const langVersionRes = await getLangVersion({ project_code: "zhiyi" });

		if (langVersionRes.code !== 200) {
			throw langVersionRes.msg || langVersionRes.messages;
		}

		const currentVersion = langVersionRes.data.version;

		/**
		 * 1. 当前语言包版本号不存在
		 * 2. 当前语言不存在
		 * 3. 当前用户语言与当前语言不一致
		 * 4. 当前语言包版本号与当前版本号不一致
		 * 5. 当前语言包不存在
		 */
		if (!currentLang || userLang !== currentLang || version !== currentVersion || !langJsonStr) {
			// 获取当前用户语言
			const langRes = await getLangJson({ lang: userLang, project_code: "zhiyi", module_id: "frontend" });

			if (langRes.code !== 200) {
				throw langRes.msg || langRes.messages;
			}

			const langData = Array.isArray(langRes.data) ? {} : langRes.data;

			// 更新localStorage
			localStorage.setItem("langVersion", currentVersion);
			localStorage.setItem("lang", userLang);
			localStorage.setItem("langJson", JSON.stringify(langData));

			location.reload();
		}
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error("[i18n] 语言包初始化异常", error);
	}
};

export default i18n;
